import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import commonFunction from "../../Utils/commonFunction";
import DefaultPagination from "../../config/Pagination";
import Pagination from ".././Common/Pagination";
import ReceiptModal from "../ProfileModals/receipt";
import { MENU_IMAGE_PATH, image_url } from "../../Utils/baseUrl";
import { DatePicker } from "antd";
import Cancelorder from "../ProfileModals/cancelorder";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { getFavouriteList, setFavorite, setFavouriteUpdated } from "../../app/favourite/favourite.slice";
import { Modal } from 'antd';
import { useNavigate } from 'react-router-dom';

const { RangePicker } = DatePicker;

function UserOrders({ isOrder }) {
  const [orders, setOrders] = useState();
  const [receiptData, setReceiptData] = useState();
  const [isRecModalOpen, setIsRecModalOpen] = useState(false);
  const [selectedDates, setSelectedDates] = useState({}); // For selecting the date range of  order transaction
  const [activeTooltipRow, setActiveTooltipRow] = useState(null);
  const [tooltipMessage, setTooltipMessage] = useState("");
  const closeRecModal = () => setIsRecModalOpen(false);
  const [isCancelOrderModalOpen, setIsCancelOrderModalOpen] = useState(false);
  const closeCancelOrderModal = () => setIsCancelOrderModalOpen(false);
  const [id, setId] = useState();
  const [orderItem, setOrderItem] = useState();
  const favouriteUpdated = useSelector((state) => state.favourite.favouriteUpdated);
  const user = useSelector((state) => state.user);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  let orderData = {
    search: "",
    pageNumber: DefaultPagination.PAGE_NUMBER,
    pageSize: DefaultPagination.PAGE_SIZE,
    startDate: selectedDates.start,
    endDate: selectedDates.end,
  };

  useEffect(() => {
    const getOrders = commonFunction.getOrders(orderData);
    getOrders.then((res) => {
      setOrders(res?.data);
    });

    window.scrollTo(0, 0);
    // eslint-disable-next-line
  }, []);

  const paginationWithPage = (pageNumber) => {
    orderData.pageNumber = pageNumber;
    const getOrders = commonFunction.getOrders(orderData);
    getOrders.then((res) => {
      setOrders(res?.data);
    });
  };

  const handleCancel = async (id, item) => {
    setOrderItem(item);
    setId(id);
    try {
      const response = await commonFunction.allowCancelOrder(id);

      if (response?.data?.status === true) {
        setIsCancelOrderModalOpen(true);
      } else {
        setTooltipMessage(response?.data.message || "Du kan ikke afbestille efter kl 06:00");
        setActiveTooltipRow(id);

        // auto hide after 5 seconds
        setTimeout(() => {
          setActiveTooltipRow(null);
        }, 5000);
      }
    } catch (err) {
      setTooltipMessage("Noget gik galt. Prøv igen.");
      setActiveTooltipRow(id);

      setTimeout(() => {
        setActiveTooltipRow(null);
      }, 5000);
    }
  };

  const handleReceipt = (data) => {
    setIsRecModalOpen(true);
    setReceiptData(data);
  };
  const convertToBackendFormat = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return `${year}-${month}-${day}`;
  };

  // For the order transaction
  const handleDateChange = async (dates, dateStrings) => {
    const formattedStartDate = dates ? convertToBackendFormat(dateStrings[0]) : "";
    const formattedEndDate = dates ? convertToBackendFormat(dateStrings[1]) : "";
    const obj = {
      start: formattedStartDate,
      end: formattedEndDate,
    };
    orderData.startDate = formattedStartDate;
    orderData.endDate = formattedEndDate;
    const getOrders = await commonFunction.getOrders(orderData);
    toast.success("Order fetched successfully");
    setSelectedDates(obj);
    setOrders(getOrders?.data);
  };

  const toggleFavorite = async (orderId) => {
    const userId = orders?.data?.order[0]?.userId;

    const response = await dispatch(setFavorite({ orderId, userId }));

    if (response?.payload?.status === false) {
      toast.error(response?.payload?.message);
      return;
    } else if (response?.payload?.status === true) {
      const getOrders = await commonFunction.getOrders(orderData);
      // getOrders?.then((res) => {
      //   setOrders(res?.data);
      // });
      setOrders(getOrders?.data);
      dispatch(getFavouriteList({
        data: {
          search: "",
          pageNumber: DefaultPagination.PAGE_NUMBER,
          pageSize: DefaultPagination.PAGE_SIZE
        }, userId
      }));
      toast.success(response?.payload?.message);
    }
  };

  const handleOpenModal = async (item) => {

    const orderDetails = await commonFunction.getOrderById(item?.id);

    const itemName = orderDetails?.data?.orderDetails?.OrdersItems[0]?.itemName;

    Modal.confirm({
      title: 'ændringsordre',
      content: `Er du sikker på du vil ændre denne "${itemName}" for noget andet?`,
      okText: 'Ja Ændre',
      cancelText: 'Nej',
      onOk() {
        localStorage.setItem("changeOrderItem", JSON.stringify(orderDetails?.data?.orderDetails)); //Save to localStorage
        localStorage.setItem("childDetails", JSON.stringify(item)); //Save child details to localStorage
        // Navigate to change order page and pass data
        navigate('/change-order', {
          state: {
            orderItem: orderDetails?.data?.orderDetails,
            childDetails: item
          }
        });
      },
      onCancel() {
        console.log("Order change aborted.");
      },
    });
  };

  const isCancelDisabled = (deliveryDate) => {
    if (!deliveryDate) return false;

    // deliveryDate format: DD/MM/YYYY
    const [day, month, year] = deliveryDate.split("/");

    const deliveryDay = Number(day);
    const deliveryMonth = Number(month);
    const deliveryYear = Number(year);

    // Get current date/time in Denmark
    const denmarkParts = new Intl.DateTimeFormat("en-GB", {
      timeZone: "Europe/Copenhagen",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(new Date());

    const getPart = (type) => denmarkParts.find((part) => part.type === type)?.value;

    const currentYear = Number(getPart("year"));
    const currentMonth = Number(getPart("month"));
    const currentDay = Number(getPart("day"));
    const currentHour = Number(getPart("hour"));
    const currentMinute = Number(getPart("minute"));

    // Convert dates to comparable numbers
    const deliveryDateNumber = deliveryYear * 10000 + deliveryMonth * 100 + deliveryDay;

    const currentDateNumber = currentYear * 10000 + currentMonth * 100 + currentDay;

    // 1. Delivery date is already passed
    if (deliveryDateNumber < currentDateNumber) {
      return true;
    }

    // 2. Delivery date is today
    if (deliveryDateNumber === currentDateNumber) {
      // Before 09:00 => can cancel
      // 09:00 or later => cannot cancel
      return currentHour >= 9;
    }
    // 3. Delivery date is in the future
    return false;
  };

  useEffect(() => {
    if (favouriteUpdated) {
      const refreshOrders = async () => {
        const updatedOrders = await commonFunction.getOrders(orderData);
        setOrders(updatedOrders?.data);
        dispatch(setFavouriteUpdated(false)); // reset flag
      };
      refreshOrders();
    }
  }, [favouriteUpdated]);

  return (
    <div
      className={isOrder ? "tab-pane fade show active" : "tab-pane fade"}
      id="order"
      role="tabpanel"
      aria-labelledby="order-tab"
    >
      <div className="tab_innerBody">
        <div className="tab_innerBodyTitle">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <h4>Mine Ordre</h4>
            <div style={{ display: "flex", width: "auto" }}>
              <h4 className="p-2">Ordrer Detaljer</h4>
              {/* <RangePicker value={selectedDates} onChange={handleDateChange} /> */}
              <RangePicker
                placeholder={["Start Dato", "Slut Dato"]}
                onChange={handleDateChange}
                format="DD/MM/YYYY"
              />
            </div>
          </div>
        </div>
        <div className="tab_subItems">
          <div className="tab_tableItem">
            <div className="text-right mb-3">
              <NavLink className="btn btn-secondary" to="/make-order">
                Opret Bestilling Her
              </NavLink>
            </div>
            <table className="table table-striped text-center myOrder" style={{ tableLayout: 'auto !important' }}>
              <thead>
                <tr>
                  <th></th>
                  <th scope="col">Bestilling ID</th>
                  <th scope="col">Barn</th>
                  <th scope="col">Bestilling</th>
                  <th scope="col">Billedet</th>
                  <th scope="col">Pris</th>
                  <th scope="col">Antal</th>
                  <th scope="col">Total</th>
                  <th scope="col">Leveringsdato</th>
                  <th scope="col">Kvittering</th>
                  <th scope="col">Slet Bestilling</th>
                  <th scope="col">Handling</th>
                </tr>
                {orders?.data?.order != undefined &&
                  orders?.data?.order.length > 0 ? (
                  orders?.data?.order.map((item, index) =>
                    item.OrdersItems.map((orderItem, index2) => (
                      <tr key={index2}>
                        <td>
                          <i
                            className={`fa-star fa ${item.isFav == "true" ? 'fa-solid' : 'fa-regular'}`}
                            style={{
                              cursor: 'pointer',
                              color: item.isFav == "true" ? '#EE4D1A' : '#999' // gold when favorited
                            }}
                            onClick={() => toggleFavorite(orderItem?.OrderId)}
                          ></i>
                        </td>
                        <td>{orderItem?.OrderId}</td>
                        <td>{item?.Child?.name}</td>
                        <td
                          dangerouslySetInnerHTML={{
                            __html: orderItem?.itemName.replace(/<[^>]+>/g, ""),
                          }}
                        >
                        </td>
                        <td>
                          <img
                            src={
                              orderItem?.image
                                ? `${image_url}${MENU_IMAGE_PATH}` +
                                orderItem?.image
                                : ""
                            }
                            alt="not found"
                            style={{ height: "50px" }}
                          />
                        </td>
                        <td>{orderItem?.price}</td>
                        <td>{orderItem?.quantity}</td>
                        <td>{item?.totalPrice}Kr</td>
                        <td>{item?.deliveryDate}</td>
                        <td>
                          <i
                            className="fa fa-file"
                            onClick={() => handleReceipt(item)}
                            style={{ cursor: "pointer" }}
                          ></i>
                        </td>
                        <td>
                          {item?.status === 1 ? (
                            <span className="tooltip-icon" onClick={() => handleCancel(orderItem?.OrderId, item)}>
                              <i
                                className="fa fa-times"
                                style={{
                                  cursor: isCancelDisabled(item?.deliveryDate)
                                    ? "not-allowed"
                                    : "pointer",
                                  color: isCancelDisabled(item?.deliveryDate)
                                    ? "lightgray"
                                    : "gray",
                                }}
                              ></i>
                              {/* Show tooltip only for this row */}
                              {activeTooltipRow === orderItem?.OrderId && (
                                <span className="tooltip-text show">{tooltipMessage}</span>
                              )}
                            </span>
                          ) : item?.status === 2 ? (
                            <>Canceled</>
                          ) : item?.status === 3 ? (
                            <>Delivered</>
                          ) : (
                            <>Unknown Status</>
                          )}
                        </td>
                        <td>
                          <i
                            className="fa fa-pen"
                            data-bs-toggle="tooltip"
                            title="Ændre Ordre"
                            onClick={() => handleOpenModal(item)}
                            style={{ cursor: 'pointer' }}
                          ></i>
                        </td>
                      </tr>
                    ))
                  )
                ) : (
                  <tr>
                    <td colSpan={9}>Ingen Bestillinger Fundet !!</td>
                  </tr>
                )}
              </thead>
            </table>
          </div>
          {/* Pagination component */}
          <Pagination
            totalPage={orders?.data?.pagination?.totalPages}
            currentPage={orders?.data?.pagination?.currentPage}
            fullPagination={paginationWithPage}
          />
        </div>
      </div>
      <ReceiptModal
        isRecOpen={isRecModalOpen}
        closeRecModal={closeRecModal}
        data={receiptData}
        userData={user}
      />
      <Cancelorder
        isCancelOrderOpen={isCancelOrderModalOpen}
        iscloseCancelOrder={closeCancelOrderModal}
        id={id}
        setOrders={setOrders}
        orderData={orderData}
        orderItem={orderItem}
      />
    </div>
  );
}

export default UserOrders;
